import { Box, Button, Checkbox, FormControl, FormControlLabel, FormHelperText, Grid, Paper, TextField, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useAddMenuPaiMutation, useGetMenuPaiQuery } from './menuPaiApiSlice';
import { ISmenuPai, MenuPai, MenuPaiDTO } from '../../../../../typesSite/menuPai/MenuPai';
import errorFormat from '../../../../../utils/errorFormat';
import TxtNoticiaSite from '../../../../autoComplete/TxtNoticiaSite';
import { Noticia } from '../../../../../typesSite/noticia/Noticia';

export const MenuPaiCreate = () => {
  const [menuPai, SetMenuPai] = useState<MenuPai>(ISmenuPai);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [createMenuPai, status] = useAddMenuPaiMutation();
  const navigate = useNavigate();

  //verificar se for edicao ele pega o id e faz a consulta
  const id = useParams().id || '';
  const { data, isFetching, error } = useGetMenuPaiQuery(id);
  useEffect(() => {
    if (data) {
      SetMenuPai(data);
    }
  }, [data, error, isFetching]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const cursorPosition = e.target.selectionStart;

    SetMenuPai(prev => ({
      ...prev,
      [name]: value
    }));

    // Aguarde até que o DOM seja atualizado
    setTimeout(() => {
      const input = e.target;
      input.setSelectionRange(cursorPosition, cursorPosition);
    }, 0);
  };

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const parms: MenuPaiDTO = {
      id: menuPai.id,
      label: menuPai.label,
      link: menuPai.link || '',
      idNoticia: menuPai.noticia?.id || '',
      ordem: menuPai.ordem || 0,
      isEscolaLegislativo: menuPai.isEscolaLegislativo || false
    };

    await createMenuPai(parms);
  }

  useEffect(() => {
    if (status.isError) {
      enqueueSnackbar('Registro não incluído!', { variant: 'error' });
      const erroReturn: string = errorFormat(status);
      enqueueSnackbar(erroReturn, { variant: 'error' });
    }

    if (status.isSuccess) {
      enqueueSnackbar('Registro incluído!', { variant: 'success' });
      navigate(-1);
      // setGrupo(ISgrupo);
    }
  }, [status]);

  return (
    <>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          mt: 4
        }}
      >
        <Paper
          elevation={3}
          sx={{
            width: {
              xs: '100%', // 100% em telas pequenas
              sm: '90%', // 90% em telas médias ou maiores
              md: '90%',
              lg: '90%'
            },
            maxWidth: '1200px', // Limite opcional
            p: 2
          }}
        >
          <Typography variant="h6" component="h1" sx={{ mb: 2 }}>
            {menuPai.id ? 'Edição' : 'Inclusão'} Menu Principal
          </Typography>

          <form onSubmit={handleSubmit} method="POST">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField required label="Descrição:" name="label" onChange={handleChange} size="small" inputProps={{ maxLength: 30 }} value={menuPai.label} />
                  <FormHelperText>{menuPai.label?.length}/30 caracteres</FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField label="Link para o Menu" name="link" onChange={handleChange} size="small" inputProps={{ maxLength: 255 }} value={menuPai.link} />
                  <FormHelperText>{menuPai.link?.length}/255 caracteres</FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Box display="flex" justifyContent="space-between" gap={2}>
                  <FormControl fullWidth>
                    <TxtNoticiaSite
                      isdisabled={false}
                      value={menuPai.noticia as Noticia}
                      handleSearchChange={it => {
                        SetMenuPai(prev => ({
                          ...prev,
                          noticia: it as Noticia
                        }));
                      }}
                    />
                  </FormControl>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label="Ordem do Link no Menu"
                    name="ordem"
                    onChange={handleChange}
                    size="small"
                    inputProps={{
                      maxLength: 3,
                      inputMode: 'numeric', // para dispositivos móveis
                      pattern: '[0-9]*' // restringe a números
                    }}
                    value={menuPai.ordem || ''}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={menuPai.isEscolaLegislativo || false}
                      onChange={e =>
                        SetMenuPai(prev => ({
                          ...prev,
                          isEscolaLegislativo: e.target.checked
                        }))
                      }
                      name="isEscolaLegislativo"
                      color="primary"
                    />
                  }
                  label="É Escola do Legislativo?"
                />
              </Grid>

              <Grid item xs={12}>
                <Box display="flex" gap={2}>
                  <Button type="submit" variant="contained" color="secondary">
                    Gravar
                  </Button>

                  <Button variant="contained" onClick={() => navigate(-1)}>
                    Voltar
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Box>
    </>
  );
};
